import React from 'react';
import styles from './Loader.module.css'; // lowercase m

const Loader = () => {
	return (
		<div className={styles.container}>
			<div className={styles.dotsSpinner}>
				<div className={styles.dot}></div>
				<div className={styles.dot}></div>
				<div className={styles.dot}></div>
			</div>
			<div className={styles.loadingText}>Loading...</div>
		</div>
	);
};

export default Loader;
